import styled from 'styled-components';
import sizes from 'styles/sizes';
import colors from 'styles/colors';
import fonts from 'styles/fonts';
import { DEFAULT } from 'components/Scroller/constants';

export const Wrapper = styled.div<{ searchFilters: string }>`
	display: flex;
	justify-content: center;
	position: sticky;
	top: -1px;
	background: inherit;
	background-attachment: fixed;

	${(props) => props.searchFilters === DEFAULT && 'padding: 24px 20px;'}

	&.isSticky {
		background: ${colors.primary.ice};
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
		z-index: 10;
	}

	&.compare {
		display: none;
	}
`;

export const Constrain = styled.div`
	display: flex;
	align-self: center;

	@media (min-width: ${sizes.media.tabletPortrait}px) {
		justify-content: center;
		flex-wrap: wrap;
		button {
			margin-top: 10px;
		}
	}

	button {
		&:not(:last-child) {
			margin-right: 10px;
		}
	}

	@media (max-width: ${sizes.media.tabletPortrait}px) {
		overflow: scroll;
		scrollbar-width: none;
		::-webkit-scrollbar {
			display: none;
			width: 0;
		}
	}
`;

export const FilterText = styled.span`
	display: none;
	font-family: ${fonts.primary.semibold};

	@media (min-width: ${sizes.media.tabletPortrait + 1}px) {
		align-self: center;
		color: ${colors.functional.darkGrey};
		display: inline;
		font-size: 16px;
		margin-right: 20px;
		opacity: 1;
		transition: all 0.3s linear;

		&.isSticky {
			opacity: 1;
		}

		&.isNoSticky {
			opacity: 0;
		}

		&.hidden {
			display: none;
		}
	}
`;
